var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "new_top" },
        [
          _c("header2"),
          _vm._v(" "),
          _c("navigation", {
            attrs: { perfectPosition: "14,null;", projectIdsC: [1] }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "new_content",
          staticStyle: { overflow: "hidden", "padding-top": "20px" }
        },
        [
          _c("div", { staticClass: "chengduzixun_left" }, [
            _c(
              "div",
              { staticClass: "flexslider", attrs: { id: "flexslider" } },
              [
                _c(
                  "el-carousel",
                  { attrs: { trigger: "click", height: "332px" } },
                  _vm._l(_vm.secondCarousel, function(item) {
                    return _c("el-carousel-item", { key: item.id }, [
                      _c("a", { attrs: { target: "_blank", href: item.url } }, [
                        _c("img", {
                          attrs: {
                            src: item.imgUrl,
                            width: "535",
                            height: "332"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "flex-caption" }, [
                        _vm._v(_vm._s(item.title))
                      ])
                    ])
                  }),
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chengduzixun_right" },
            [
              _c("newsSimpleList", {
                staticClass: "f_l",
                attrs: { settings: _vm.noticeNewsSettings }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("footer1")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8519a06a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8519a06a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NewsList.vue
// module id = null
// module chunks = 